export const ExtensionName = `MyDataGoWhere?!`;
export const ExtensionId = `my-data-go-where`;

export * from "./APIs";
export {commonPathTermsToIgnore} from "./commonPathTermsToIgnore"

export interface HasLicenseRestrictionText {
	licenseRestrictionText?: string | undefined; 
}

export const UnlicensedText = `
This report was generated by MyDataGoesWhere?! exclusively to inform the user who generated it.
This report may not be used for any audit-for hire, as evidence in a class action or mass arbitration, or other commercial purpose
without a license from the software's author.
`.replaceAll(/[\s\t\n\r]+/g, ' ')
.trim();;


